module.exports = __webpack_public_path__ + "media/images/admin/icons/upload-1020a0aa83f58bcb205328a98107740b.svg";